function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  x: "21",
  y: "4",
  width: "4",
  height: "18",
  rx: "2",
  transform: "rotate(90 21 4)",
  fill: "#5B6073"
}), /*#__PURE__*/React.createElement("rect", {
  x: "21",
  y: "10",
  width: "4",
  height: "18",
  rx: "2",
  transform: "rotate(90 21 10)",
  fill: "#5B6073"
}), /*#__PURE__*/React.createElement("rect", {
  x: "21",
  y: "16",
  width: "4",
  height: "18",
  rx: "2",
  transform: "rotate(90 21 16)",
  fill: "#5B6073"
}));